module.exports = __webpack_public_path__ + "static/media/eventcalendar.635626db.svg";